import React from 'react'
import styled from 'styled-components'
import { Button } from 'primereact/button'

import Text from '../../../ui/Text'
import { SAlert } from '../../../common/features/chargepoint-details-widget/chargepoint-details-widget.styles'
import useText from '../../../common/hooks/useText'

export type UserAgreementProps = {
    cancel: () => void
    accept: () => void
    errorMessage: string | null
}

const SButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
    letter-spacing: 1%;
    gap: 8px;
    font-size: 16px;
`

const SText = styled.div`
    font-size: 20px;
    line-height: 38px;
    text-align: center;
    letter-spacing: 1%;
    a {
        color: #006ef0;
    }
    a:hover {
        cursor: pointer;
        color: #8abfff;
    }
`

export function UserAgreement({ cancel, accept, errorMessage }: UserAgreementProps): React.ReactElement {
    const text = useText()

    return (
        <div className={'row'}>
            <div className="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2 solid">
                {errorMessage && (
                    <SAlert type="error" className="margin-top-small" data-testid="alert-error">
                        {errorMessage}
                    </SAlert>
                )}
                <SText className="row margin-top-med margin-bottom-med" data-testid="info">
                    <Text
                        code="msgUserAgreementInfo"
                        values={{
                            link: {
                                href: `https://www.chargeamps.com/${text('linkTermsOfService')}`,
                                target: '_new',
                            },
                            link2: {
                                href: `https://www.chargeamps.com/${text('linkPrivacyPolicy')}`,
                                target: '_new',
                            },
                        }}
                    ></Text>
                </SText>
                <SButtonGroup>
                    <Button type="button" label={text('btnAccept')} onClick={() => accept()} data-testid="accept-btn" />
                    <Button
                        type="button"
                        label={text('btnCancel')}
                        text
                        onClick={() => cancel()}
                        data-testid="cancel-btn"
                    />
                </SButtonGroup>
            </div>
        </div>
    )
}
